function setCookie(cname, cvalue, exdays, domain) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie =
    cname +
    '=' +
    cvalue +
    ';' +
    expires +
    ';path=/' +
    (domain ? ';domain=' + domain : '');
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// The cookie banner (CookieModal) stores a timestamp in lb-cc for "Accept
// all" and 'false' for "Only necessary"; no cookie means no answer yet.
function hasAcceptedAllCookies() {
  const consent = getCookie('lb-cc');
  return !!consent && consent !== 'false';
}

export { getCookie, setCookie, hasAcceptedAllCookies };
